/*
 *
 * MarketingPage reducer
 *
 */

import { fromJS } from 'immutable';
import {
  RESET_PASSWORD,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_SUCCESS,
} from './constants';

export const initialState = fromJS({
  authenticated: false,
  message: '',
});

function resetPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_PASSWORD:
      return state.set('loading', true);
    case RESET_PASSWORD_ERROR:
      return state
        .set('loading', false)
        .setIn(['error', 'loginError'], action.error.data.error);
    case RESET_PASSWORD_SUCCESS:
      return state
        .set('loading', false)
        .set('message', action.user.message)
        .setIn(['error', 'loginError'], '');
    default:
      return state;
  }
}

export default resetPasswordReducer;
